/**
 * Assets API Client
 */

import type { Asset, AssetStats, AssetsFilter } from '../../domain/types'

const mockAssets: Asset[] = [
  {
    tenantId: 'tenant-1', category: 'VEHICLE', make: 'Generic', driverId: 'DRV-001', id: 'AST-001',
    assetNumber: 'TRK-001',
    name: { en: 'Bulker Truck #1', ar: 'شاحنة أعلاف سائبة #1' },
    type: 'truck',
    status: 'available',
    ownership: 'owned',
    plateNumber: 'ABC-1234',
    model: 'Mercedes Actros',
    manufacturer: 'Mercedes-Benz',
    year: 2022,
    capacity: { value: 40, unit: 'tons' },

    driverName: 'Mohammed Ahmed',
    currentProjectId: 'PRJ-001',
    currentProjectName: 'Al-Riyadh Tower',
    lastMaintenance: '2024-10-15',
    nextMaintenance: '2025-01-15',
    createdAt: '2022-03-15',
    updatedAt: '2024-11-01',
  },
  {
    tenantId: 'tenant-1', category: 'VEHICLE', make: 'Generic', driverId: 'DRV-001', id: 'AST-002',
    assetNumber: 'MXR-001',
    name: { en: 'Flat Bed Truck #1', ar: 'شاحنة مسطحة #1' },
    type: 'truck',
    status: 'available',
    ownership: 'leased',
    plateNumber: 'DEF-5678',
    model: 'Putzmeister',
    capacity: { value: 12, unit: 'm³' },
    currentProjectId: 'PRJ-002',
    currentProjectName: 'Jeddah Waterfront',
    lastMaintenance: '2024-09-20',
    nextMaintenance: '2024-12-20',
    createdAt: '2023-06-01',
    updatedAt: '2024-10-25',
  },
  {
    tenantId: 'tenant-1', category: 'VEHICLE', make: 'Generic', driverId: 'DRV-001', id: 'AST-003',
    assetNumber: 'TRK-002',
    name: { en: 'Bulker Truck #2', ar: 'شاحنة أعلاف سائبة #2' },
    type: 'truck',
    status: 'maintenance',
    ownership: 'owned',
    plateNumber: 'GHI-9012',
    model: 'Volvo FH16',
    manufacturer: 'Volvo',
    year: 2021,
    capacity: { value: 35, unit: 'tons' },
    lastMaintenance: '2024-11-25',
    nextMaintenance: '2024-12-10',
    createdAt: '2021-08-20',
    updatedAt: '2024-11-25',
  },
  {
    tenantId: 'tenant-1', category: 'VEHICLE', make: 'Generic', driverId: 'DRV-001', id: 'AST-004',
    assetNumber: 'PMP-001',
    name: { en: 'Flat Bed Truck #2', ar: 'شاحنة مسطحة #2' },
    type: 'truck',
    status: 'out-of-service',
    ownership: 'owned',
    model: 'Schwing S36',
    capacity: { value: 100, unit: "m³" },
    lastMaintenance: '2024-08-10',
    nextMaintenance: '2025-02-10',
    createdAt: '2020-05-15',
    updatedAt: '2024-08-10',
  },
]

const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))

export const assetsApi = {
  async getAssets(filter?: AssetsFilter): Promise<Asset[]> {
    await delay(300)
    let result = [...mockAssets]

    if (filter?.status && filter.status !== 'all') {
      result = result.filter(a => a.status === filter.status)
    }
    if (filter?.type && filter.type !== 'all') {
      result = result.filter(a => a.type === filter.type)
    }
    if (filter?.ownership && filter.ownership !== 'all') {
      result = result.filter(a => a.ownership === filter.ownership)
    }
    if (filter?.search) {
      const search = filter.search.toLowerCase()
      result = result.filter(a =>
        a.assetNumber.toLowerCase().includes(search) ||
        a.name.en.toLowerCase().includes(search) ||
        a.plateNumber?.toLowerCase().includes(search)
      )
    }

    return result
  },

  async getAsset(id: string): Promise<Asset | null> {
    await delay(200)
    return mockAssets.find(a => a.id === id) || null
  },

  async getAssetStats(): Promise<AssetStats> {
    await delay(200)
    return {
      active: mockAssets.filter(a => a.status === 'available').length,
      maintenance: mockAssets.filter(a => a.status === 'maintenance').length,
      idle: mockAssets.filter(a => a.status === 'out-of-service').length,
      total: mockAssets.length,
      owned: mockAssets.filter(a => a.ownership === 'owned').length,
      leased: mockAssets.filter(a => a.ownership === 'leased').length,
    }
  },
}
